module.exports = __webpack_public_path__ + "static/media/original(2).9a5db5ef.png";